import { Injectable, signal } from '@angular/core';
import { ToastItem, ToastPosition } from './toast';

@Injectable({
  providedIn: 'root',
})
export class UiToastService {
  private idCounter = 0;
  readonly toasts = signal<ToastItem[]>([]);

  show(position: ToastPosition, type: ToastItem['severity'], summary: string, detail: string): void {
    const id = ++this.idCounter;
    const toast: ToastItem = { id, severity: type, summary, detail, position, visible: true };

    this.toasts.update((current) => [...current, toast]);

    setTimeout(() => {
      this.toasts.update((current) =>
        current.map((t) => (t.id === id ? { ...t, visible: false } : t))
      );
      setTimeout(() => this.remove(id), 300);
    }, 5000);
  }

  remove(id: number): void {
    this.toasts.update((current) => current.filter((t) => t.id !== id));
  }

  clear(position?: ToastPosition): void {
    if (position) {
      this.toasts.update((current) => current.filter((t) => t.position !== position));
    } else {
      this.toasts.set([]);
    }
  }
}
